var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4316 6.93164V19.2207C19.4316 19.3704 19.3043 19.4998 19.1553 19.5H1.82129C1.67615 19.5 1.54395 19.3746 1.54395 19.2207V6.93164H19.4316ZM7.33203 8.46484C6.65174 8.46484 6.05469 9.022 6.05469 9.74512V11.3281C6.05471 12.0066 6.60724 12.6074 7.33203 12.6074H13.6436C14.3238 12.6074 14.9209 12.0512 14.9209 11.3281V9.74512C14.9209 9.06667 14.3684 8.46484 13.6436 8.46484H7.33203Z",
    stroke: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.777344 0.5H20.1992C20.3333 0.500219 20.4852 0.618148 20.5 0.824219V4.88379H0.5V0.779297C0.500134 0.629595 0.628241 0.5 0.777344 0.5Z",
    stroke: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageIcon);
export default __webpack_public_path__ + "static/media/storage-icon.40be6da49f1f0c6dda6a2f973188b488.svg";
export { ForwardRef as ReactComponent };